Solution1.vue<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/banner-solution.png`)})`}">
			<div class="container">
				<h2 class="w-600 title text-left color-white banner-text mb--0">金融業綜合服務方案</h2>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">解決方案</h2>
				<div class="solution" data-aos="fade-up" data-aos-delay="100">
					<div class="pic">
						<img src="@/assets/images/s2-1.jpg" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="t1">金融級算力基礎設施</div>
						<div class="t2">
							✅ 搭載高性能處理器的伺服器集群提供高性能計算能力，支援千億級金融交易並發處理，滿足高頻交易、實時風控等場景需求。<br>
							✅ 通過動態資源分配技術，實現CPU/GPU/NPU算力協同，支撐大模型訓練與推理，提升信貸審批等業務響應速度。<br>
							✅ 智能信貸風控服務，集成DeepSeek-R1千億參數大模型，實現小微企業信貸盡調報告自動生成，數據歸集時間從72小時縮短至2小時，人力節省90%。
						</div>
					</div>
				</div>
				<div class="solution solution-r" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						<div class="t1">全生命周期數據安全管控平台</div>
						<div class="t2">
							✅ 敏感數據識別：通過分類分級模板（如GDPR/《數據安全法》要求）自動標記客戶身份證號、交易記錄等字段。<br>
							✅ 精細化權限控制：支援行級/列級數據訪問權限，結合RBAC模型與雙因子認證，非法訪問攔截率100%。<br>
							✅ SQL審計與攔截：實時檢測高危操作（如批量導出），通過語義分析阻斷異常查詢，風險操作發現時效＜1秒。<br>
							✅ 全鏈路審計：記錄從登錄到操作的全流程日誌，支援回溯分析，審計報告生成效率提升80%。
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/s2-2.jpg" style="border-radius: 12px;">
					</div>
				</div>
				<div class="solution" data-aos="fade-up" data-aos-delay="100">
					<div class="pic">
						<img src="@/assets/images/s2-3.jpg" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="t1">雲原生安全架構</div>
						<div class="t2">
							✅ AI驅動的攻防演練：基於機器學習模擬APT攻擊，提前修復漏洞，防禦成功率提升至95%。<br>
							✅ 微服務安全網關：集成WAF、API防火牆，攔截SQL注入、DDoS等攻擊，誤報率＜0.1%。<br>
							✅ 全網可觀測性：通過流量鏡像+AI分析，實時繪製威脅圖譜，異常流量檢測延遲＜50ms。<br>
							✅ 零信任架構：動態驗證設備/用戶身份，默認拒絕所有訪問請求，橫向滲透風險降低70%。
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'

export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/sbg.jpg");
}
.solution {
	margin-top: 72px;
	display: flex;
	gap: 40px;
	.pic {
		width: 40%
	}
	.txt {
		flex: 1;
		.t1 {
			font-size: 24px;
			font-weight: 600;
			color: #000;
		}
		.t2 {
			margin-top: 12px;
			color: #000;
		}
	}
}
@media only screen and (max-width: 768px) {
	.solution {
		flex-direction: column;
		gap: 20px;
		.pic {
			width: 100%;
		}
		.txt {
			width: 100%;
		}

		&.solution-r {
			flex-direction: column-reverse;
		}
	}
}
.banner-text {
	text-shadow:
		0 0 2px black,
		0 0 2px black,
		0 0 2px black,
		0 0 2px black;
}
</style>
